const BusinessWebsite = () => {
  return (
    <div className="mt-8">
      <table>
        <tr className="flex w-[678px] items-center justify-between">
          <td className="font-pop text-2xl font-bold text-darkGreen">
            Website
          </td>
          <td className="font-regular font-pop text-xl text-darkGreen text-opacity-70">
            www.topgun.com
          </td>
        </tr>
      </table>
      <div className="mt-5">
        <h5 className="font-pop text-2xl font-bold text-darkGreen">
          What we do
        </h5>
        <p className="mt-2 w-[931px] font-pop text-base font-semibold leading-7 text-black text-opacity-70">
          The purpose of lorem ipsum is to create a natural looking block of
          text (sentence, paragraph, page, etc.) that doesn't distract from the
          layout. A practice not without controversy, laying out pages with
          meaningless filler text can be very useful when the
        </p>
      </div>
      <div className="mt-12">
        <h5 className="font-pop text-2xl font-bold text-darkGreen">
          Service Area’s
        </h5>
        <p className="mt-5 w-[931px] font-pop text-base font-semibold leading-7 text-black text-opacity-70">
          The purpose of lorem ipsum is to create a natural looking block of
          text (sentence, paragraph, page, etc.) that doesn't distract from the
          layout. A practice not without controversy, laying out pages with
          meaningless filler text can be very useful when the
        </p>
      </div>
      <table className="mt-8">
        <tr className="flex w-[678px] items-center justify-between">
          <td className="font-pop text-2xl font-bold text-darkGreen">
            We Accept
          </td>
          <td className="font-regular font-pop text-xl text-primary text-opacity-70">
            Master Card, Visa, Cash, Cheq
          </td>
        </tr>
      </table>
    </div>
  );
};

export default BusinessWebsite;
